import { z } from "zod";
export const VOTE_DOWN = -1;
export const VOTE_UP = 1;
export const VoteSchema = z.object({
    vote: z.union([z.literal(-1), z.literal(1)]),
});
